/* eslint-disable import/no-unresolved */
export default [
  {
    path: '/search',
    component: () => import('./pages/search.layout'),
    children: [
      {
        path: 'project',
        component: () => import('./pages/page-search-project'),
        name: 'search-project'
      },
      {
        path: 'company',
        component: () => import('./pages/page-search-company'),
        name: 'search-company'
      },
      {
        path: 'user',
        component: () => import('./pages/page-search-user'),
        name: 'search-user'
      },
      {
        path: 'package',
        component: () => import('./pages/page-search-package'),
        name: 'search-package'
      },
      {
        path: 'container',
        component: () => import('./pages/page-search-container'),
        name: 'search-container'
      },
      {
        path: 'topic',
        component: () => import('./pages/page-search-topic'),
        name: 'search-topic'
      },
      {
        path: 'code',
        component: () => import('./pages/page-search-code'),
        name: 'search-code',
        children: [
          {
            path: 'repo',
            component: () => import('./pages/page-search-code'),
            name: 'search-code-repo'
          }
        ]
      },
    ]
  }
];
